import { useEffect, useRef, useState } from "react";
import Cross from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from "react-redux";
import { closeModal, setModal, setSelectedProduct, updateInventoryProducts } from "../../../../Features/inventoryManagementSlice";
import { useOutsideClickHandler } from "../../../../Hooks/useOutsideClick";
import AddBlue from '../../../../Assets/Modals/AddBlue.svg';
import { useNavigate } from "react-router-dom";
import { addSizeChartToProduct, cachedDataPublish, getSizeChartById } from "../../../../lib/utils/apiCalls";
import { showToast } from '../../../../Components/Toaster/Toaster';
import LoadingTransparent from "../../../../Components/Loading/LoadingTransparent";

function UpdateSizeChart() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const wrapperRef = useRef(null);

    const [loading, setLoading] = useState(false);

    const sizeCharts = useSelector((state) => state.inventoryManagement.sizeCharts.sizeCharts);
    const selectedProduct = useSelector((state) => state.inventoryManagement.selectedProduct);
    const { products } = useSelector((state) => state.inventoryManagement.products);

    useOutsideClickHandler(wrapperRef, () => {
        handleCloseModal();
    });

    const [buttonAvailable, setButtonAvailable] = useState(true);
    const [selectedSizeChart, setSelectedSizeChart] = useState({});

    const handleRadioSelection = (sizeChart) => {
        setSelectedSizeChart(sizeChart);
    }

    async function handleApply() {
        setLoading(true);
        if(buttonAvailable) {
            try {
                const callBody = {
                    sizeChartId: selectedSizeChart.id,
                }

                const response = await addSizeChartToProduct(callBody, selectedProduct.product.id);
                if(response.status === 200) {
                    await cachedDataPublish([`/v1/product/${selectedProduct?.product?.id}`]);
                    showToast('Size Chart updated to Product.', 'success');
                    const newProductsArray = products.map(item =>
                        item.product.id === selectedProduct.product.id
                            ? {
                                ...item,
                                product: { ...response.data.data },
                            }
                            : item
                    );

                    dispatch(updateInventoryProducts(newProductsArray));
                    setLoading(false);
                    handleCloseModal();
                }
                else {
                    setLoading(false);
                    showToast('Failed to update size chart to product.', 'error');
                }
            }
            catch(err) {
                setLoading(false);
                showToast('Failed to update size chart to product.', 'error');
            }
        }
    }

    function handleCloseModal() {
        dispatch(closeModal());
        dispatch(setSelectedProduct({}));
    }

    function handleAddNewSizeChart() {
        dispatch(closeModal());
        dispatch(setSelectedProduct({}));
        navigate('size-charts');
        setTimeout(() => {
            dispatch(setModal('select-size-chart-type'));
        }, 300);
    }

    useEffect(() => {
        if(Object.keys(selectedSizeChart).length > 0) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [selectedSizeChart]);

    async function getSizeChartInfo(chartId) {
        try {
            const response = await getSizeChartById(chartId);
            if(response.status === 200) {
                setSelectedSizeChart(response.data.data);
            }
        }
        catch(err) {
            showToast('Failed to fetch size chart.', 'error');
        }
    }

    useEffect(() => {
        if(Object.keys(selectedProduct).length > 0) {
            getSizeChartInfo(selectedProduct?.product?.SizeChartId);
        }
    }, [selectedProduct]);

    return (
        <div ref={wrapperRef} className="w-[44%] p-6 pt-[18px] bg-[#FFFFFF] rounded-xl flex flex-col gap-6">
            <div className="flex flex-col gap-3 w-full">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <h1 className='font-semibold text-2xl text-[#121212]'>Select Size Chart</h1>
                    </div>

                    <button onClick={handleCloseModal} className="w-11 h-11 flex items-center justify-center">
                        <img src={Cross} alt="" />
                    </button>
                </div>

                {
                    sizeCharts.length > 0 ? 
                    (
                        <div className="flex flex-col gap-3 max-h-44 overflow-y-scroll">
                            {sizeCharts?.map(sizeChart => {
                                return (
                                    <label key={sizeChart.id} className="m-0 flex items-center gap-2 cursor-pointer px-3" htmlFor={sizeChart.chartName}>
                                        <input 
                                            value={sizeChart.chartName} 
                                            type="radio" 
                                            name={sizeChart.chartName} 
                                            id={sizeChart.chartName} 
                                            checked={selectedSizeChart.chartName === sizeChart.chartName} 
                                            onChange={() => handleRadioSelection(sizeChart)} 
                                            className='hidden' 
                                        />

                                        <div className={`w-4 h-4 flex items-center justify-center rounded-full border ${selectedSizeChart.chartName === sizeChart.chartName ? 'border-primaryColor' : 'border-[#757575]'}`}>
                                            {selectedSizeChart.chartName === sizeChart.chartName && <div className="w-2 h-2 rounded-full bg-primaryColor"></div>}
                                        </div>
                                        {sizeChart.chartName} &#40;{sizeChart.chartType}&#41;
                                    </label>
                                );
                            })}
                        </div>
                    ) : 
                    <p className='italic text-[14px] leading-[22px] text-[#666666]'>There are no size charts.</p>
                }

                <button onClick={handleAddNewSizeChart} className="flex items-center">
                    <div className="size-6 flex items-center justify-center">
                        <img src={AddBlue} alt="" />
                    </div>

                    <p className="text-link text-base font-medium">Add New Size Chart</p>
                </button>
            </div>

            <button onClick={handleApply} className={`px-4 py-2 ${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'} text-buttonText rounded font-semibold text-base`}>Apply</button>
        
            {loading && <LoadingTransparent message="Updating size chart..." />}
        </div>
    )
}

export default UpdateSizeChart;
